import practice_requests from './practice'
import generalPractitioner_requests from './generalPractitioner'

const requests = {
    practice: practice_requests,
    generalPractitioner: generalPractitioner_requests
}

export default requests
